import { HttpClient } from "@angular/common/http";
import { Directive, Injectable, Input } from "@angular/core";
import {
  Validator,
  NG_ASYNC_VALIDATORS,
  AbstractControl,
  ValidationErrors,
  AsyncValidator,
} from "@angular/forms";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";

@Directive({
  selector: "[IsValidPassword]",
  providers: [
    {
      provide: NG_ASYNC_VALIDATORS,
      useExisting: IsValidPasswordDirective,
      multi: true,
    },
  ],
})
export class IsValidPasswordDirective implements AsyncValidator {
  @Input("username") username: Text;
  constructor(private httpClient: HttpClient) {}

  validate(
    control: AbstractControl
  ): Promise<ValidationErrors> | Observable<ValidationErrors> {
    let result: any;
    let password = control.value;
    let username = this.username;
    return this.httpClient
      .post<any>(`/PasswordPolicy/IsValidPassword`, {
        username: username,
        password: password,
      })
      .pipe(
        map((res) => {
                   if (res.IsValid === true) {
            return null;
          } else {
            let errors:any;
            return res;
          }
        })
      );
  }
}
